module.exports = __webpack_public_path__ + "assets/icons/current-location.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/current-location.png
// module id = ./src/styles/icons/current-location.png
// module chunks = 0